import { render, staticRenderFns } from "./ServiceHistoryItem.vue?vue&type=template&id=6fa3f912&scoped=true&"
import script from "./ServiceHistoryItem.vue?vue&type=script&lang=js&"
export * from "./ServiceHistoryItem.vue?vue&type=script&lang=js&"
import style0 from "./ServiceHistoryItem.vue?vue&type=style&index=0&id=6fa3f912&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa3f912",
  null
  
)

export default component.exports